import { editorEnum } from 'src/model/editor/editorEnum'
import {
  formatPrice,
  getPaymentFrequency,
} from '../../simple-box-wrapper-options/utils'
import { resolveFont, resolvePrimaryColor } from 'src/utils/workspace-logo'

export const headerPromoTemplate = (
  landingPageData,
  course,
  collection,
  pageUrl,
  collectionSettings,
  collectionGeneralSettings,
  certificatePayment,
) => {
  if (landingPageData) {
    // A page on the default color shows the workspace branding's (buttons,
    // links and the title too), as learners see it.
    landingPageData = {
      ...landingPageData,
      primaryColor: resolvePrimaryColor(landingPageData.primaryColor),
    }
    // The same URL on every render: a cache-busting timestamp made the browser
    // download the logo again each time, so the header jumped while it loaded.
    // A new logo is a new file, so a stale one can't show.
    const logoUrl = landingPageData.logo
      ? landingPageData.logo.startsWith('https')
        ? landingPageData.logo
        : `https://cdn.minicoursegenerator.com/${landingPageData.logo}`
      : ''

    // Get landing page section
    const landingPageSection = landingPageData?.sections?.find(
      x => x.type === editorEnum.headerType,
    )

    // Get course/collection data
    const title =
      pageUrl === 'mini-course'
        ? course?.name ||
        'Collection/Course Title Collection/Course Title Collection/Course Title'
        : collection?.name ||
        'Collection/Course Title Collection/Course Title Collection/Course Title'

    // Get description from settings instead of course/collection data
    const description =
      landingPageSection?.content?.description ||
      (pageUrl === 'mini-course'
        ? course?.description || ''
        : collection?.description || '')

    // Get features from theme settings
    const features = landingPageSection?.content?.features || [
      { id: 1, text: 'Feature one', checked: true, icon: 'material-symbols:check-rounded' },
      { id: 2, text: 'Feature two', checked: true, icon: 'material-symbols:check-rounded' },
      { id: 3, text: 'Feature three', checked: true, icon: 'material-symbols:check-rounded' },
      { id: 4, text: 'Feature four', checked: true, icon: 'material-symbols:check-rounded' },
    ]

    // Get thumbnail image from theme settings
    const thumbnailImage =
      landingPageSection?.content?.thumbnailImage ||
      'https://cdn.minicoursegenerator.com/assets/editor/header-card-thumbnail.jpg'
    // Ensure thumbnail image URL is properly formatted
    const thumbnailImageUrl = thumbnailImage.startsWith('http')
      ? thumbnailImage
      : thumbnailImage.startsWith('/')
        ? `https://cdn.minicoursegenerator.com${thumbnailImage}`
        : `https://cdn.minicoursegenerator.com/${thumbnailImage}`

    // Get price data
    const priceTagActive = landingPageSection?.content?.priceTagActive
    // Generate features HTML
    const primaryColor = landingPageData.primaryColor || '#015FFB'
    const defaultIcon = 'material-symbols:check-rounded'
    const encodedColor = encodeURIComponent(primaryColor)
    const featuresHtml = features
      .filter(feature => feature.checked)
      .map(feature => {
        const featureIcon = feature.icon || defaultIcon
        const iconPath = featureIcon.replace(':', '/')
        const iconUrl = `https://api.iconify.design/${iconPath}.svg?color=${encodedColor}`

        return `
      <div class="promo-feature-item">
        <img src="${iconUrl}" class="promo-check-icon" alt="" width="24" height="24" />
        <span class="promo-feature-text" style="font-family: ${resolveFont(landingPageData.font)
          } !important; color: #002E47 !important">${feature.text}</span>
      </div>
    `
      })
      .join('')

    return `
      <div class="promo-template-container">
        <!-- Logo Section -->
       

        <!-- Main Promo Content -->
        <div class="promo-main-content" >
          <!-- Left Content -->
          <div class="promo-left-content">
            <h1 class="promo-title" style="font-family: ${resolveFont(landingPageData.font)
      } !important; color: ${landingPageData.textColor || '#FFFFFF'
      } !important; display: -webkit-box !important; -webkit-line-clamp: 2 !important; -webkit-box-orient: vertical !important; overflow: hidden !important; text-overflow: ellipsis !important;">${title}</h1>
            
            <p class="promo-description" style="font-family: ${resolveFont(landingPageData.font)
      } !important; color: ${landingPageData.textColor || '#FFFFFF'
      } !important; display: ${description ? '-webkit-box' : 'none'
      } !important; -webkit-line-clamp: 4 !important; -webkit-box-orient: vertical !important; overflow: hidden !important; text-overflow: ellipsis !important;">${description || ''
      }</p>
               <!-- Read More Button at Bottom -->
        
          </div>

          <!-- Right Content -->
          <div class="promo-right-content">
            <!-- Hero Image -->
            <div class="promo-image-container">
              <div class="promo-image-placeholder">
               ${landingPageData.logo
        ? `<div class="promo-logo-container">
                <img 
                  src="${logoUrl}" 
                  class="promo-logo" 
                  alt="logo" 
                />
              </div>`
        : ''
      }
                <img 
                  src="${thumbnailImageUrl}" 
                  alt="Course thumbnail" 
                  class="promo-thumbnail-image"
                />
              </div>
            </div>
          <div class="${priceTagActive ? 'promo-right-content-inner-price' : 'promo-right-content-inner'}">

            ${(() => {
        if (pageUrl !== 'mini-course' && collection.type !== 1) {
          return `
                  <div class="course-container-header-price" style="font-family: ${resolveFont(landingPageData.font)
            } !important; display: ${priceTagActive ? 'block' : 'none'}">
                                           <p><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                       <path d="M17.4703 7.5803L11.0503 1.1703C10.8868 1.00581 10.6711 0.903291 10.4403 0.880297L1.0903 0.000296701C0.943829 -0.0131743 0.796192 0.00583103 0.657911 0.0559579C0.51963 0.106085 0.39411 0.186099 0.290297 0.290297C0.186099 0.39411 0.106085 0.51963 0.0559579 0.657911C0.00583103 0.796192 -0.0131743 0.943829 0.000296701 1.0903L0.880297 10.4403C0.903291 10.6711 1.00581 10.8868 1.1703 11.0503L7.5803 17.4703C7.92409 17.8094 8.38741 17.9997 8.8703 18.0003C9.35015 17.9993 9.81018 17.8088 10.1503 17.4703L17.4703 10.1503C17.8104 9.80914 18.0014 9.34704 18.0014 8.8653C18.0014 8.38355 17.8104 7.92145 17.4703 7.5803ZM7.5603 7.5803C7.35059 7.79026 7.08332 7.93331 6.7923 7.99134C6.50128 8.04937 6.19958 8.01977 5.92538 7.90629C5.65118 7.79282 5.41681 7.60056 5.2519 7.35385C5.087 7.10713 4.99898 6.81705 4.99898 6.5203C4.99898 6.22355 5.087 5.93346 5.2519 5.68675C5.41681 5.44003 5.65118 5.24778 5.92538 5.1343C6.19958 5.02082 6.50128 4.99123 6.7923 5.04926C7.08332 5.10728 7.35059 5.25033 7.5603 5.4603C7.83754 5.73943 7.99313 6.11688 7.99313 6.5103C7.99313 6.90371 7.83754 7.28116 7.5603 7.5603V7.5803Z" fill="${landingPageData.primaryColor ||
            '#015FFB'
            }"/>
                                     </svg> ${collectionGeneralSettings?.price &&
              collectionGeneralSettings?.accessRule ==
              4
              ? formatPrice(
                collectionGeneralSettings.price,
              ) +
              `<span class="course-container-price-title">${getPaymentFrequency(
                collectionGeneralSettings.price,
              ).label
              }</span>`
              : 'Free'
            }</</p>
                                           </div>
                                           <hr class="price-divider" style="display: ${priceTagActive ? 'block' : 'none'
            }">
                `
        }
        return ''
      })()}

            <!-- Features List -->
            <div class="promo-features-list">
              ${featuresHtml}
            </div>

            ${(() => {
        // Check if it's a showcase collection (type === 1)
        const isShowcaseCollection = collection?.type === 1

        // Show button for courses and non-showcase collections
        if (pageUrl === 'mini-course' || !isShowcaseCollection) {
          return `
            <!-- Get Started Button -->
            <button class="promo-get-started-btn" style="background-color: ${landingPageData.primaryColor || '#015FFB'
            } !important; font-family: ${resolveFont(landingPageData.font)
            } !important">
                ${landingPageData?.localizations?.startButton ||
            (pageUrl === 'mini-course' ? 'Start Course' : 'Get Started')
            }
              </button>
            `
        }
        return ''
      })()}
            ${(() => {
        // Paid certificate indicator — mirrors the learner-app pill
        // (mcg-frontend-app `certificate-indicator/index.tsx`). Sits below
        // the Get Started button, centered text, no leading icon.
        if (
          !certificatePayment?.isConfigured ||
          !certificatePayment.amount ||
          pageUrl === 'mini-course'
        ) {
          return ''
        }
        const accent = landingPageData.primaryColor || '#015FFB'
        const fontFamily = resolveFont(landingPageData.font)
        const certFreq = getPaymentFrequency(certificatePayment).label
        const certPrice = formatPrice(certificatePayment)
        return `
                  <div class="certificate-indicator" style="display: flex !important; align-items: center !important; justify-content: center !important; padding: 8px 16px !important; height: 44px !important; box-sizing: border-box !important; border-radius: 8px !important; border: 1px solid #E0E5EB !important; background-color: #FFFFFF !important; font-size: 16px !important; font-family: ${fontFamily} !important; color: #212B36 !important; margin-top: 12px !important; text-align: center !important;">
                    <span>Verified Certificate Available: <strong style="color: ${accent}; font-weight: 600; margin-left: 4px;">${certPrice}</strong>${certFreq ? `<span style="color: #637381; font-weight: 400;"> ${certFreq}</span>` : ''}</span>
                  </div>
                `
      })()}
            </div>
          </div>
        </div>
        
     
      </div>
    `
  }
  return ''
}
